<script setup lang="ts">
import { useToastStore } from '@/stores/toast.store'

const toast = useToastStore()
</script>

<template>
  <div class="toast-stack">
    <v-snackbar
      v-for="t in toast.items"
      :key="t.id"
      :model-value="true"
      :color="t.type"
      :timeout="t.timeout"
      location="top right"
      variant="elevated"
      @update:model-value="(v) => !v && toast.close(t.id)"
    >
      {{ t.text }}
      <template #actions>
        <v-btn icon="mdi-close" variant="text" size="small" @click="toast.close(t.id)" />
      </template>
    </v-snackbar>
  </div>
</template>

<style scoped>
.toast-stack {
  position: relative;
  z-index: 9999;
}
</style>
